package com.ives.utils;

class BrowserVersion {
	private var regexes:Array<EReg> = [];

	public var name:String;
	public var minimal:Array<Int>;
	public var version:Array<Int>;

	public function new(name:String, regexes:Array<String>, version:Array<Int>) {
		this.name = name;
		this.minimal = version;

		for(regex in regexes)
			this.regexes.push(new EReg(regex, "i"));
	}

	public function matches(userAgent:String):Bool{
		for(regex in regexes)
			if(regex.match(userAgent)){
				version = stringToVersion(regex.matched(1));

				return true;
			}

		return false;
	}

	private function stringToVersion(versionString:String):Array<UInt>{
		Log.debug('Version string ${versionString}');

		var parts:Array<String> = versionString.split(".");

		var ints:Array<UInt> = [];

		for(part in parts)
			ints.push(Std.parseInt(part));

		return ints;
	}

	public function versionCheck():Bool{
		if(version.length > minimal.length)
			return false;

		for(n in 0...version.length){
			if(version[n] > minimal[n])
				return true;

			if(version[n] < minimal[n])
				return false;
		}

		return true;
	}
}
